import { post, get, baseURL } from "@/utils/request";

export const getDailyBetRewards = (param: any) => get(`/activity/activityDailyBetRewards/info?pageNum=${param.pageNum}&pageSize=${param.pageSize}`);

export const getDailyBetRewardsClaim = (data: any) => post(`/activity/activityDailyBetRewards/claim`, data);

export const getLossReliefRewardsInfo = (param: any) => get(`/activity/activityLossReliefRewardsInfo?pageNum=${param.pageNum}&pageSize=${param.pageSize}&orderByColumn=day&isAsc=desc`);

export const getDailyLossRewardsClaim = (data: any) => post(`/activity/activityLossReliefRewards/claim`, data);

export const getDailyRechargeRewardsClaim = (data: any) => post(`/activity/collectRechargeGift`, data);

export const getFirstRechargeClaim = (data: any) => post(`/activity/claimFirstRechargeReward`, data);

export const getRemainBet = () => get(`/activity/activityDailyBetRewards/calculate`);

export const getVIPRewardInfo = () => get(`/activity/getVIPRewardInfo`);

export const getVIPRewardHistory = (param: any) => get(`/activity/getVIPRewardHistory?pageNum=${param.pageNum}&pageSize=${param.pageSize}`);

export const getVIPClaim = (data: any) => post(`/activity/vipRewardClaim`, data);

export const getPhoneVerification = (data: any) => post(`/signIn/phoneVerification`, data);

export const getOtpVerification = (data: any) => post(`/signIn/otpVerification`, data);

export const checkinRewardClaim = (param: any) => post(`/activity/signinReward/selectClaimType?claimType=${param.type}`)

export const checkinRewardStatus = () => get(`/activity/signinReward/status`)

export const checkinClaimRewards = (data: any) => post(`/activity/activitySignInReward/claimReward`, data)

export const checkinRewardsHistory = () => get(`/activity/getSigninRewardHistory`)

export const activeTreasureClaim = (data: any) => post(`/activeTreasureChest/claim`, data)

export const getPlayerClaimHistory = (data: any) => post(`/activeTreasureChest/history?claimStatus=${data.status}&pageNum=${data.pageNum}&pageSize=${data.pageSize}`)

export const getActiveBonusInfo = () => get(`/activity/getActiveBonusInfo`)

export const activeBonuseClaim = (data: any) => post(`/activity/ActiveBonus/claim`, data)

export const claimDailyTreasure = (data: any) => post(`/activity/dailyTreasureChest/claim`, data)

export const getDailyTreasureReward = () => get(`/activity/dailyTreasureChest/getOrCalculateReward`)

export const claimReturnTreasure = (data: any) => post(`/activity/claimReturnTreasureChest`, data)

export const getReturnTreasureReward = (data: any) => post(`/activity/getRewardAmountAndTimes`, data)

export const getLoginTreasureReward = () => post(`/activity/LoginTreasureChest/calculateReward`)

export const claimLoginTreasure = (data: any) => post(`/activity/LoginTreasureChest/claim`, data)

export const getNextdayTreasureReward = () => get(`/activity/nextDayTreasureChest/getOrCalculateReward`)

export const claimNextdayTreasure = (data: any) => post(`/activity/nextDayTreasureChest/claim`, data)